// @ts-nocheck
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import AffiliateShell from './components/AffiliateShell'
import MissedCallsPanel from './components/MissedCallsPanel'
import {AFF, card} from './components/affiliateTheme'
import {getAffiliateDashboard, getAffiliateCustomers} from './core/_requests'

const Kpi = ({icon, color, value, label, sub}) => (
  <div className='col-sm-6 col-xl-3'>
    <div style={{...card, padding: 22, height: '100%'}}>
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 12,
          background: color + '1a',
          color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 14,
        }}
      >
        <i className={`bi ${icon}`} style={{fontSize: 22}} />
      </div>
      <div style={{fontSize: 30, fontWeight: 700, color: AFF.ink, lineHeight: 1}}>{value}</div>
      <div style={{fontWeight: 600, color: AFF.ink, marginTop: 8}}>{label}</div>
      {sub && <div style={{fontSize: 12.5, color: AFF.muted, marginTop: 2}}>{sub}</div>}
    </div>
  </div>
)

const AffiliateDashboardWrapper = () => {
  const {currentUser} = useAuth()
  const [dash, setDash] = useState<any>(null)
  const [customers, setCustomers] = useState<any[]>([])
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    getAffiliateDashboard().then((r) => setDash(r.data)).catch(() => {})
    getAffiliateCustomers().then((r) => setCustomers(r.data || [])).catch(() => {})
  }, [])

  const code = dash?.affiliate_code || currentUser?.affiliate_code || ''
  const refLink = `https://fbzipper.com/auth/registration?aff=${code}`
  // Self-registration link where the client picks their yad2 agent.
  const registerLink = code ? `https://console.fbzipper.com/auth/yad2-register?aff=${code}` : ''
  // Same signup without the yad2 agent picker / import.
  const normalLink = code ? `https://console.fbzipper.com/auth/register?aff=${code}` : ''
  const tiers = dash?.tiers || []
  const payers = dash?.current_month_payers ?? 0

  // Next-tier progress
  const nextTier = tiers.find((t) => payers < t.min)
  const progressPct = nextTier ? Math.min(100, Math.round((payers / nextTier.min) * 100)) : 100

  const copy = () => {
    navigator.clipboard?.writeText(refLink)
    setCopied(true)
    setTimeout(() => setCopied(false), 1800)
  }
  const [copiedReg, setCopiedReg] = useState(false)
  const copyReg = () => {
    navigator.clipboard?.writeText(registerLink)
    setCopiedReg(true)
    setTimeout(() => setCopiedReg(false), 1800)
  }
  const [copiedNormal, setCopiedNormal] = useState(false)
  const copyNormal = () => {
    navigator.clipboard?.writeText(normalLink)
    setCopiedNormal(true)
    setTimeout(() => setCopiedNormal(false), 1800)
  }

  return (
    <AffiliateShell
      title={`שלום ${currentUser?.first_name || ''} 👋`}
      subtitle='עקוב אחר הלקוחות, העמלות והרווחים שלך במקום אחד.'
      action={
        <Link
          to='/affiliate/add-customer'
          className='btn'
          style={{background: '#fff', color: AFF.accent, fontWeight: 700, borderRadius: 10}}
        >
          <i className='bi bi-person-plus me-2' />
          הוספת לקוח חדש
        </Link>
      }
    >
      <MissedCallsPanel />

      {/* KPI row */}
      <div className='row g-4 mb-4'>
        <Kpi icon='bi-people-fill' color={AFF.accent} value={dash?.referred_customers ?? '—'} label='סה"כ לקוחות' sub='לקוחות שהוספת לתוכנית' />
        <Kpi icon='bi-check-circle-fill' color={AFF.success} value={payers} label='שילמו החודש' sub='תשלום ראשון בחודש הנוכחי' />
        <Kpi icon='bi-tag-fill' color={AFF.warning} value={dash ? `₪${dash.projected_rate}` : '—'} label='עמלה ללקוח' sub='לפי המדרגה החודשית' />
        <Kpi icon='bi-wallet2' color='#8b5cf6' value={dash ? `₪${(dash.projected_earnings ?? 0).toLocaleString()}` : '—'} label='רווח צפוי החודש' sub={`${payers} × ₪${dash?.projected_rate ?? 0}`} />
      </div>

      <div className='row g-4'>
        {/* Referral link + tier ladder */}
        <div className='col-xl-7'>
          <div style={{...card, padding: 24, marginBottom: 20}}>
            <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 6}}>קישור הרשמה לסוכן יד2</div>
            <div style={{fontSize: 13, color: AFF.muted, marginBottom: 14}}>
              הלקוח בוחר את עצמו ממאגר הסוכנים של יד2, משויך אליך אוטומטית, והנכסים שלו מתחילים להתפרסם.{' '}
              <Link to='/affiliate/client-register' style={{color: AFF.accent, fontWeight: 600}}>
                שליחה בוואטסאפ »
              </Link>
            </div>
            <div style={{display: 'flex', gap: 8}}>
              <input
                readOnly
                value={registerLink}
                dir='ltr'
                className='form-control'
                style={{background: AFF.accentSoft, border: 'none', fontWeight: 600, color: AFF.ink}}
                onFocus={(e) => e.target.select()}
              />
              <button className='btn' style={{background: AFF.accent, color: '#fff', fontWeight: 600, whiteSpace: 'nowrap'}} onClick={copyReg}>
                <i className={`bi ${copiedReg ? 'bi-check2' : 'bi-clipboard'} me-1`} />
                {copiedReg ? 'הועתק' : 'העתק'}
              </button>
            </div>

            {/* Plain signup link — no yad2 import. */}
            <div style={{borderTop: `1px solid ${AFF.border}`, marginTop: 18, paddingTop: 18}}>
              <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 6}}>קישור הרשמה רגיל (ללא ייבוא יד2)</div>
              <div style={{fontSize: 13, color: AFF.muted, marginBottom: 14}}>
                הרשמה רגילה ללא בחירת סוכן יד2 — הלקוח משויך אליך אוטומטית.
              </div>
              <div style={{display: 'flex', gap: 8}}>
                <input
                  readOnly
                  value={normalLink}
                  dir='ltr'
                  className='form-control'
                  style={{background: AFF.accentSoft, border: 'none', fontWeight: 600, color: AFF.ink}}
                  onFocus={(e) => e.target.select()}
                />
                <button className='btn' style={{background: AFF.accent, color: '#fff', fontWeight: 600, whiteSpace: 'nowrap'}} onClick={copyNormal}>
                  <i className={`bi ${copiedNormal ? 'bi-check2' : 'bi-clipboard'} me-1`} />
                  {copiedNormal ? 'הועתק' : 'העתק'}
                </button>
              </div>
            </div>
          </div>

          <div style={{...card, padding: 24}}>
            <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 4}}>מבנה העמלות המדורג</div>
            <div style={{fontSize: 13, color: AFF.muted, marginBottom: 18}}>
              ככל שיותר לקוחות משלמים בחודש — העמלה לכל לקוח עולה (ומוחלת על כולם).
            </div>

            {nextTier && (
              <div style={{marginBottom: 20}}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6}}>
                  <span style={{color: AFF.muted}}>עוד {nextTier.min - payers} לקוחות למדרגה הבאה (₪{nextTier.rate})</span>
                  <span style={{fontWeight: 700, color: AFF.accent}}>{payers}/{nextTier.min}</span>
                </div>
                <div style={{height: 8, background: AFF.border, borderRadius: 99}}>
                  <div style={{height: 8, width: `${progressPct}%`, background: AFF.accentGrad, borderRadius: 99, transition: 'width .4s'}} />
                </div>
              </div>
            )}

            <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
              {tiers.map((t, i) => {
                const upper = tiers[i + 1] ? tiers[i + 1].min - 1 : null
                const active = payers >= t.min && (!tiers[i + 1] || payers < tiers[i + 1].min)
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '12px 16px',
                      borderRadius: 12,
                      border: `1px solid ${active ? AFF.accent : AFF.border}`,
                      background: active ? AFF.accentSoft : '#fff',
                    }}
                  >
                    <div style={{fontWeight: 600, color: AFF.ink}}>
                      {t.min}{upper ? `–${upper}` : '+'} לקוחות בחודש
                      {active && <span className='badge ms-2' style={{background: AFF.accent, color: '#fff'}}>המדרגה שלך</span>}
                    </div>
                    <div style={{fontWeight: 700, color: AFF.accent, fontSize: 18}}>₪{t.rate}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* Recent customers + payouts */}
        <div className='col-xl-5'>
          <div style={{...card, padding: 24, marginBottom: 20}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
              <span style={{fontWeight: 700, color: AFF.ink}}>לקוחות אחרונים</span>
              <Link to='/affiliate/customers' style={{fontSize: 13, color: AFF.accent, fontWeight: 600}}>הצג הכל</Link>
            </div>
            {customers.length === 0 ? (
              <div style={{color: AFF.muted, textAlign: 'center', padding: '24px 0'}}>עדיין אין לקוחות</div>
            ) : (
              customers.slice(0, 5).map((c) => (
                <div key={c._id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${AFF.border}`}}>
                  <div>
                    <div style={{fontWeight: 600, color: AFF.ink}}>{[c.first_name, c.last_name].filter(Boolean).join(' ') || c.email}</div>
                    <div style={{fontSize: 12, color: AFF.muted}} dir='ltr'>{c.email}</div>
                  </div>
                  {c.is_paying ? (
                    <span className='badge badge-light-success'>משלם</span>
                  ) : c.trial_active ? (
                    <span className='badge badge-light-primary'>ניסיון</span>
                  ) : (
                    <span className='badge badge-light-danger'>פג תוקף</span>
                  )}
                </div>
              ))
            )}
          </div>

          <div style={{...card, padding: 24}}>
            <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 16}}>תשלומים אחרונים</div>
            {(!dash?.payouts || dash.payouts.length === 0) ? (
              <div style={{color: AFF.muted, textAlign: 'center', padding: '24px 0'}}>אין תשלומים שהוקפאו עדיין</div>
            ) : (
              dash.payouts.slice(0, 5).map((p) => (
                <div key={p._id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${AFF.border}`}}>
                  <div>
                    <div style={{fontWeight: 600, color: AFF.ink}}>{p._id}</div>
                    <div style={{fontSize: 12, color: AFF.muted}}>{p.count} לקוחות · {p.statuses.join(', ')}</div>
                  </div>
                  <div style={{fontWeight: 700, color: AFF.ink}}>₪{(p.total || 0).toLocaleString()}</div>
                </div>
              ))
            )}
            <Link to='/affiliate/payouts' className='btn btn-light w-100 mt-3' style={{fontWeight: 600}}>
              לכל התשלומים
            </Link>
          </div>
        </div>
      </div>
    </AffiliateShell>
  )
}

export default AffiliateDashboardWrapper
